import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";

import { format } from "date-fns";

import Ageing from "./Componets/Ageing";
import AgeingDetail from "./Componets/AgeingDetail";
import CollectionOutstanding from "./Componets/CollectionOutstanding";
import Monthly from "./Componets/Monthly";
import ReceiptMonthWise from "./Componets/ReceiptMonthWise";
import ReceiptACYear from "./Componets/ReceiptACYear";
import ReceiptAccount from "./Componets/ReceiptAccount";
import Detail from "./Componets/Detail";
import { Loader } from "../../../../../src/components/Loader/Loader";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import FASFilterBox from "../../../../components/FilterBox/FASFilter/FASFilter";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { AcList } from "../../../../Redux/Slice/Fas/Financial Statement/Ledger/LedgerSlice";
import {
  RecAdjDtl,
  RecAdjDtldataFun,
  RecAdjDtlFun,
  RecAging,
  RecAgingDtl,
  RecAgingDtlFun,
  RecAgingFun,
  RecOutstanding,
  RecOutstandingFun,
  RecPayMonth,
  RecPayMonthFun,
  RecReceiptAc,
  RecReceiptAcFun,
  RecReceiptAcYear,
  RecReceiptAcYearFun,
  RecReceiptMonth,
  RecReceiptMonthFun,
} from "../../../../Redux/Slice/Fas/ReceivablePayble/ReceivablePaybleSlice";
import { useTheme } from "../../../../Themecontext/Themecontext";
import Calendar from "react-calendar";
import FASCalender from "../../../../components/Calendar/FASCalender";

export const Receivable = () => {
  const dispatch = useDispatch();

  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");

  const [activeTab, setActiveTab] = useState("AGEING");
  const [slotSize, setSlotSize] = useState("15");
  const [showFilter, setShowFilter] = useState(false);
  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  const { Colourdata, mainFilterData, DataMain } = useSelector(
    (state) => state.ClientLogin,
  );
  const { AcListdata } = useSelector((state) => state.LedgerSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const actionButtons = [
    "AGEING",
    "AGEING DETAIL",
    "COLLECTION OUTSTANDING",
    "DETAIL",
    "MONTHLY",
    "RECEIPT MONTHWISE",
    "RECEIPT ACCOUNT",
    "RECEIPT YEAR",
  ];
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  useEffect(() => {
    dispatch(AcList({ Firm: Firm, Year: FinancialYear }));
  }, [dispatch, Firm, FinancialYear]);

  useEffect(() => {
    const isSingle = singleSelectPages.includes(activeTab);

    setFilters((prev) => {
      return {
        ...prev,
        ProductionGroup: isSingle
          ? prev.ProductionGroup.length > 0
            ? [prev.ProductionGroup[0]]
            : []
          : prev.ProductionGroup,

        Account: isSingle
          ? prev.Account.length > 0
            ? [prev.Account[0]]
            : []
          : prev.Account,
      };
    });
  }, [activeTab]);

  const [filters, setFilters] = useState({
    ProductionGroup: [],
    Account: [],
  });

  const [search, setSearch] = useState({
    ProductionGroup: "",
    Account: "",
  });

  const ProductionGroupList =
    mainFilterData?.production_Group_Master_List?.map((item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    })) || [];

  const AccountList =
    AcListdata?.RecAcList?.map((item) => ({
      label: item?.AcName,
      value: item?.AcID,
    })) || [];

  const singleSelectPages = [
    "AGEING",
    "RECEIPT MONTHWISE",
    "MONTHLY",
    "RECEIPT MONTHWISE",
    "COLLECTION OUTSTANDING",
    "AGEING",
  ];

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];
      let updatedSelection = [];

      // ✅ check current page single hai ya nahi
      const isSingle = singleSelectPages.includes(activeTab);

      if (type === "Account") {
        updatedSelection = selected.includes(item.value) ? [] : [item.value];
      } else if (type === "ProductionGroup") {
        if (isSingle) {
          updatedSelection = selected.includes(item.value) ? [] : [item.value];
        } else {
          updatedSelection = selected.includes(item.value)
            ? selected.filter((i) => i !== item.value)
            : [...selected, item.value];
        }

        // ✅ API call
        dispatch(
          AcList({
            Firm: Firm,
            Year: FinancialYear,
            selectedIds1: updatedSelection.toString(),
          }),
        );
      }

      return {
        ...prev,
        [type]: updatedSelection,
      };
    });
  };

  const selectAll = (type, items) => {
    const isSingle = singleSelectPages.includes(activeTab);

    if (isSingle) return;

    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  useEffect(() => {
    if (!startDate || !endDate) return;
    dispatch(RecAgingDtlFun());
    dispatch(RecAdjDtlFun());
    dispatch(RecReceiptAcYearFun());
    dispatch(RecReceiptAcFun());
    dispatch(RecAgingFun());
    dispatch(RecReceiptMonthFun());
    dispatch(RecOutstandingFun());
    dispatch(RecPayMonthFun());
    dispatch(RecAdjDtldataFun());

    const payload = {
      Firm: Firm,
      Year: FinancialYear,
      selectedIds: filters.ProductionGroup.toString(),
      selectedId1: filters.Account.toString(),
      startDate: safeFormat(startDate),
      endDate: safeFormat(endDate),
      SlotSize: slotSize,
    };

    switch (activeTab) {
      case "AGEING":
        dispatch(RecAging(payload));
        break;

      case "AGEING DETAIL":
        dispatch(RecAgingDtl(payload));
        break;

      case "COLLECTION OUTSTANDING":
        dispatch(RecOutstanding(payload));
        break;

      case "DETAIL":
        dispatch(RecAdjDtl(payload));
        break;

      case "MONTHLY":
        dispatch(RecPayMonth(payload));
        break;

      case "RECEIPT MONTHWISE":
        dispatch(RecReceiptMonth(payload));
        break;

      case "RECEIPT ACCOUNT":
        dispatch(RecReceiptAc(payload));
        break;

      case "RECEIPT YEAR":
        dispatch(RecReceiptAcYear(payload));
        break;

      default:
        dispatch(RecAging(payload));
    }
  }, [activeTab, filters, startDate, endDate, Firm, FinancialYear, slotSize]);

  const renderPage = () => {
    switch (activeTab) {
      case "AGEING":
        return <Ageing setSlotSize={setSlotSize} slotSize={slotSize} />;
      case "AGEING DETAIL":
        return <AgeingDetail />;
      case "COLLECTION OUTSTANDING":
        return <CollectionOutstanding />;
      case "DETAIL":
        return <Detail />;
      case "MONTHLY":
        return <Monthly />;
      case "RECEIPT MONTHWISE":
        return <ReceiptMonthWise />;
      case "RECEIPT ACCOUNT":
        return <ReceiptAccount />;
      case "RECEIPT YEAR":
        return <ReceiptACYear />;
      default:
        return <Ageing />;
    }
  };

  const filterVisiblePages = [
    "AGEING DETAIL",
    "RECEIPT YEAR",
    "RECEIPT ACCOUNT",
    "DETAIL",
  ];

  if (AcListdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      <style>{`
        .hover-scale-btn {
          transition: transform 0.2s ease-in-out;
          transform: scale(1);
        }

        .hover-scale-btn:hover {
          transform: scale(1.02);
        }
      `}</style>

      {/* MOBILE FILTER BUTTON */}
      <div
        className="d-lg-none"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "12px",
        }}
      >
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* OFFCANVAS FILTER */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Row
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* 🔷 DATE RANGE */}
            <Col>
              <div>
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10,
                    padding: "13px 20px",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Date Range
                  </h3>
                </div>

                <div
                  style={{
                    border: `2px solid ${
                      isdark === "light"
                        ? iscolour?.Colour4
                        : iscolourDark?.Colour10
                    }`,
                    padding: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    borderRadius: "0px 0px 10px 10px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      padding: "10px",
                      border: `2px solid ${
                        isdark === "light"
                          ? iscolour?.Colour4
                          : iscolourDark?.Colour10
                      }`,
                      borderRadius: "8px",
                      cursor: "pointer",
                      color:
                        isdark === "light" ? "#000" : iscolourDark?.Colour11,
                      textAlign: "center",
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(
                          dateRange[0].endDate,
                          "dd-MM-yyyy",
                        )}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>
            </Col>

            {/* 🔷 PRODUCTION GROUP */}

            {/* 🔷 ACCOUNT (CONDITIONAL) */}
            {filterVisiblePages.includes(activeTab) && (
              <Col xs={12}>
                <FASFilterBox
                  title="Account Name"
                  items={AccountList}
                  search={search.Account}
                  setSearch={(val) => handleSearch("Account", val)}
                  selectedItems={filters.Account}
                  toggleItem={(item) => toggleItem("Account", item)}
                  selectAll={() => selectAll("Account", AccountList)}
                />
              </Col>
            )}
            <Col>
              <div className="mb-3">
                <FASFilterBox
                  title="Production Group"
                  items={ProductionGroupList}
                  search={search.ProductionGroup}
                  setSearch={(val) => handleSearch("ProductionGroup", val)}
                  selectedItems={filters.ProductionGroup}
                  toggleItem={(item) => toggleItem("ProductionGroup", item)}
                  selectAll={() =>
                    selectAll("ProductionGroup", ProductionGroupList)
                  }
                />
              </div>
            </Col>
          </Row>
        </Offcanvas.Body>
      </Offcanvas>

      <Row className="align-items-start">
        {/* DESKTOP FILTER */}
        <Col xl={3} lg={4} md={12} className="d-none d-lg-block">
          <div
            style={{
              top: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "18px",
            }}
          >
            <div>
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour10,
                  padding: "13px 20px",
                  borderRadius: "10px 10px 0px 0px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {" "}
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                  padding: "15px",

                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour1,
                  borderRadius: "0px 0px 10px 10px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    marginTop: "8px",
                    padding: "10px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                    borderRadius: "8px",
                    cursor: "pointer",
                    color: isdark === "light" ? "#000" : iscolourDark?.Colour11,
                    textAlign: "center",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>

            {filterVisiblePages.includes(activeTab) && (
              <FASFilterBox
                title="Account Name "
                items={AccountList}
                search={search.Account}
                setSearch={(val) => handleSearch("Account", val)}
                selectedItems={filters.Account}
                toggleItem={(item) => toggleItem("Account", item)}
                selectAll={() => selectAll("Account", AccountList)}
              />
            )}

            <FASFilterBox
              title="Production Group"
              items={ProductionGroupList}
              search={search.ProductionGroup}
              setSearch={(val) => handleSearch("ProductionGroup", val)}
              selectedItems={filters.ProductionGroup}
              toggleItem={(item) => toggleItem("ProductionGroup", item)}
              selectAll={() =>
                selectAll("ProductionGroup", ProductionGroupList)
              }
            />
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col xl={9} lg={8} md={12}>
          <Row className="g-2 mb-3">
            {actionButtons.map((btn, index) => {
              const isActive = activeTab === btn;

              return (
                <Col xl={3} lg={4} md={6} sm={6} xs={12} key={index}>
                  <button
                    onClick={() => setActiveTab(btn)}
                    className="hover-scale-btn"
                    style={{
                      width: "100%",
                      height: "58px",
                      backgroundColor: isActive
                        ? isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10
                        : isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour3,
                      border: `2px solid ${
                        isActive
                          ? isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour10
                          : isdark === "light"
                            ? iscolour?.Colour4
                            : iscolourDark?.Colour10
                      }`,
                      borderRadius: "14px",
                      fontWeight: "bold",
                      color: isActive
                        ? isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1
                        : isdark === "light"
                          ? iscolour?.Colour11
                          : iscolourDark?.Colour9,
                      fontSize: "14px",
                    }}
                  >
                    {btn}
                  </button>
                </Col>
              );
            })}
          </Row>

          {renderPage()}
        </Col>
      </Row>
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <FASCalender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour12
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
